export default __webpack_public_path__ + "static/media/man-mountain-biking_1f6b5-200d-2642-fe0f.9c86adf1.png";